import React, {FC} from 'react'
import {ServiceRequestModal} from '../../../../../components/ServiceResquests/Modal'
import {Input} from '../../../../../components/Input/Input'
import {Button} from '../../../../../components/Button/Button'
import {Loading} from '../../../../../components/Loading/Loading'
import {i18n} from '../../../../../translate/i18n'

type GridHotelFeedback = {
  id: number
  title: string
  status: boolean
  content: {
    config: string[]
  }
}

interface GridSelectionModalProps {
  isOpen: boolean
  grids: GridHotelFeedback[]
  loading: boolean
  searchQuery: string
  selectedGridIds: number[]
  filteredGrids: GridHotelFeedback[]
  onSearchChange: (query: string) => void
  onToggleGrid: (gridId: number) => void
  onClose: () => void
  onConfirm: () => void
}

const GridSelectionModal: FC<GridSelectionModalProps> = ({
  isOpen,
  grids,
  loading,
  searchQuery,
  selectedGridIds,
  filteredGrids,
  onSearchChange,
  onToggleGrid,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null

  return (
    <ServiceRequestModal
      onCloseAction={onClose}
      title={i18n.t('service_requests.grid_services_title')}
    >
      <div>
        {/* Cabeçalho com busca */}
        <div className='mb-4'>
          <Input
            inputAttr={{type: 'default'}}
            label={i18n.t('service_requests.grid_services_search')}
            value={searchQuery}
            change={onSearchChange}
            placeholder={i18n.t('service_requests.search_placeholder')}
          />

          <div className='d-flex justify-content-between align-items-center mt-3 pt-3'>
            <span className='text-muted small'>
              {i18n.t('service_requests.grid_services_label')}
            </span>
            <div className='d-flex align-items-center gap-2'>
              <span className='text-muted small'>
                {i18n.t('service_requests.grid_services_selected_label')}
              </span>
              <span className='badge badge-light-primary fs-7'>{selectedGridIds.length}</span>
            </div>
          </div>
        </div>

        {/* Lista de grades */}
        <div className='mb-4 pb-4 border-bottom'>
          {loading ? (
            <div className='text-center py-5'>
              <Loading />
            </div>
          ) : filteredGrids.length === 0 ? (
            <div className='text-center text-muted py-5'>
              {searchQuery
                ? i18n.t('service_requests.no_grid_found')
                : i18n.t('service_requests.no_grid_available')}
            </div>
          ) : (
            <div className='d-grid gap-4'>
              {filteredGrids.map((grid) => (
                <div
                  key={grid.id}
                  className={`border rounded p-3 ${
                    selectedGridIds.includes(grid.id)
                      ? 'border-primary bg-light-primary'
                      : 'border-light'
                  }`}
                  onClick={() => onToggleGrid(grid.id)}
                  style={{
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    backgroundColor: selectedGridIds.includes(grid.id) ? undefined : '#f5f8fa',
                  }}
                >
                  <div className='d-flex align-items-center justify-content-between'>
                    <div className='flex-grow-1 d-flex align-items-center justify-content-between py-1'>
                      <h6 className='mb-1'>{grid.title}</h6>
                      <span className={`badge ${grid.status ? 'badge-success' : 'badge-danger'}`}>
                        {grid.status
                          ? i18n.t('service_requests.grid_status_active')
                          : i18n.t('service_requests.grid_status_inactive')}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Botões de ação */}
        <div className='d-flex justify-content-end gap-2'>
          <Button
            text={i18n.t('service_requests.cancel_button')}
            color='danger'
            size='small'
            btnAttr={{type: 'button'}}
            click={onClose}
          />
          <Button
            text={i18n.t('service_requests.save_button')}
            color='primary'
            size='small'
            btnAttr={{type: 'button'}}
            click={onConfirm}
            disabled={selectedGridIds.length === 0}
          />
        </div>
      </div>
    </ServiceRequestModal>
  )
}

export {GridSelectionModal}
